import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  createNewCompanyLoginScreenNarrative,
  getCompanyLoginScreenNarrative,
  selectClientPortalLoginIsLoading,
  selectClientPortalLoginScreenNarrative,
  updateCompanyLoginScreenNarrative,
} from "./ClientPortalLoginSlice";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import CPLTextEditor from "app/modules/shared/cplTextEditor/CPLTextEditor";
import { Form, Formik } from "formik";
import { LoginScreenNarrativeModel } from "services/api/cplauthapi/CPLAuthAPI";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";

const ClientPortalLoginScreenForm = () => {
  const thunkDispatch = useThunkDispatch();
  const isLoading = useSelector(selectClientPortalLoginIsLoading);
  const loginScreenNarrative = useSelector(selectClientPortalLoginScreenNarrative);

  useEffect(() => {
    thunkDispatch(getCompanyLoginScreenNarrative());
    // eslint-disable-next-line
  }, []);

  async function saveCompanyBranding(newValue: LoginScreenNarrativeModel) {
    if (loginScreenNarrative == null) {
      await thunkDispatch(createNewCompanyLoginScreenNarrative({ loginScreenNarrative: newValue.pageDescription! }));
      thunkDispatch(getCompanyLoginScreenNarrative());
    } else {
      newValue.loginScreenNarrativeID = loginScreenNarrative.loginScreenNarrativeID;
      thunkDispatch(updateCompanyLoginScreenNarrative({ loginScreenNarrative: newValue }));
    }
  }

  return (
    <div className="card d-inline-flex">
      <ActivityIndicator isBusy={isLoading}>
        <div className="card-header">
          <div className="card-title">Login Screen Narrative</div>
        </div>
        <div className="card-body">
          <Formik
            initialValues={
              loginScreenNarrative ?? new LoginScreenNarrativeModel({ loginScreenNarrativeID: 0, pageDescription: "" })
            }
            onSubmit={(values) => {
              saveCompanyBranding(values);
            }}
            enableReinitialize
          >
            {({ values, setFieldValue }) => (
              <Form>
                <CPLTextEditor
                  data-test-id="login-screen-narrative-form__page-description-text-editor"
                  value={values.pageDescription}
                  onChange={(value) => {
                    setFieldValue("pageDescription", value);
                  }}
                  disabled={isLoading}
                  height={200}
                  allowImages={false}
                  enableAutoComplete={false}
                />
                <Permission permissionPredicate={(permission) => permission === Permissions.EditCompanyBranding}>
                  <button
                    data-test-id="login-screen-narrative-form__save-button"
                    className="btn btn-primary"
                    type="submit"
                  >
                    Save
                  </button>
                </Permission>
              </Form>
            )}
          </Formik>
        </div>
      </ActivityIndicator>
    </div>
  );
};

export default ClientPortalLoginScreenForm;
